export const odinFirstGame = {
  id: 'odin-first-game',
  title: 'Pierwsza partia',
  requiredModuleIds: ['base'],
  recommendedConfiguration: {
    playerCount: 3,
    activeModuleIds: ['base', 'norwegians'],
    rounds: 7,
  },
  intro: `Ten tryb prowadzi przez pierwszą pełną partię według Twojej aktualnej konfiguracji. Nie zmienia zasad i nie stosuje skróconego scenariusza. Status treści: PARTIAL — ikony konkretnych pól odczytuj z planszy akcji.`,
  steps: [
    {
      id: 'fg-setup',
      title: 'Przygotuj stół',
      body: `Użyj strony planszy akcji odpowiadającej aktualnej liczbie graczy. Wyłóż dostępne plansze wysp z gry podstawowej oraz pozostałe elementy wspólnego obszaru zgodnie z rozdziałem przygotowania. Przy 4 graczach w podstawowej wersji zastosuj elementy rozszerzające planszę akcji wskazane dla tej liczby graczy. Ustaw tor na 7 rund.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-setup-norwegians',
      title: 'Przygotuj stół — Norwegowie',
      body: `Odłóż podstawową planszę akcji. Użyj trzech plansz akcji z dodatku, stroną odpowiadającą liczbie graczy. Wyłóż cztery nowe wyspy Norwegów oraz poprawione wyspy podstawowe zgodnie z liczbą graczy (przy 3: jedną A/B i jedną C/D; przy 4: wszystkie cztery). Rozdaj każdemu losową szopę rzemieślniczą. Przygotuj nowe dobra, małą emigrację i żetony PZ. Nie używaj żetonów powtórzeń akcji z podstawy.`,
      requiredModuleIds: ['base', 'norwegians'],
    },
    {
      id: 'fg-explain-boards',
      title: 'Wyjaśnij plansze graczy',
      body: `Pokaż pola ujemne, linię dochodu i pola premii. Zademonstruj na dwóch kaflach, że czerwone i pomarańczowe dobra nie mogą stykać się bokami, ale mogą rogami. Pokaż, że symbol dochodu i premii pozostaje odkryty. Powiedz wprost: zakrycie minusa nie daje punktów — tylko usuwa karę.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-explain-actions',
      title: 'Wyjaśnij koszt kolumn',
      body: `Kolumny 1–4 kosztują odpowiednio 1–4 wikingów. Gracze kolejno zajmują wolne pola i wykonują ikony od lewej. Po spasowaniu gracz nie wraca już do akcji w tej rundzie. Osoba, która spasuje jako pierwsza, otrzymuje znacznik pierwszego gracza na następną rundę. Nie wybieraj pola, jeśli nie stać cię na obowiązkowy koszt.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-explain-fifth-column',
      title: 'Wyjaśnij piątą kolumnę',
      body: `Piąta kolumna używa 1 albo 2 wikingów, ale kończy wszystkie twoje akcje w rundzie. Dwa wikingi pozwalają dodatkowo zagrać pomocnika. Nie używaj piątej kolumny, dopóki nie wykonasz wszystkich ważnych akcji z kolumn 1–4.`,
      requiredModuleIds: ['base', 'norwegians'],
    },
    {
      id: 'fg-round-1',
      title: 'Runda 1 — zdobądź podstawy',
      body: `Najpierw spójrz na planszę osady: jedno pole ujemne, jedna linia dochodu, jedna luka na większy kafel. Potem wybierz akcje. Każdy powinien pozyskać dobra do pierwszej biesiady oraz przynajmniej jeden element rozwoju: łódź, budynek, zwierzęta albo zestaw kafli. Nie próbuj jeszcze wypełniać całej planszy.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-round-2-3',
      title: 'Rundy 2–3 — uruchom dochód',
      body: `Przed każdym położeniem kafla sprawdzaj linię dochodu i premie. Dąż do co najmniej jednej łatwej premii. Zacznij przygotowywać łódź do wyprawy, wielorybnictwa albo emigracji. Po fazie akcji nie pomijaj dochodu, rozmnażania, biesiady i premii.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-animals-norwegians',
      title: 'Zwierzęta i działania Norwegów',
      body: `Owce, krowy i klacze używają strony ciężarnej (jeden krok na fazę). Dwie lub więcej świń dają jedną nową świnię. Grabież wymaga knary i nie jest Najazdem ani Plądrowaniem. Mała emigracja usuwa wielorybnik w zamian za żeton na stole biesiadnym.`,
      requiredModuleIds: ['base', 'norwegians'],
    },
    {
      id: 'fg-round-4-5',
      title: 'Rundy 4–5 — specjalizacja',
      body: `Wybierz główny kierunek: wyspa, duży budynek, zwierzęta, działania militarne albo emigracja. Skup się na jednym lub dwóch źródłach punktów zamiast rozpraszać rozwój. Pilnuj miejsca na duże kafle i żetony specjalne.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-craft-shed',
      title: 'Szopa rzemieślnicza',
      body: `Rozważ budowę rozdanej szopy rzemieślniczej zamiast zwykłej szopy. Jest szopą, ale nie domem. Punkty nadrukowane na łodzi lub zwierzęciu umieszczonym na szopie nie są liczone osobno przy punktacji. Ruda na wielorybniku położonym na szopie przepada.`,
      requiredModuleIds: ['base', 'norwegians'],
    },
    {
      id: 'fg-round-6-7',
      title: 'Rundy 6–7 — domknij punktację',
      body: `Policz widoczne minusy. Najpierw zakryj najbardziej kosztowne pola, potem wykorzystaj niewydane łodzie i karty. Nie inwestuj w nową planszę, której nie zdołasz sensownie wypełnić przed końcem.`,
      requiredModuleIds: ['base'],
    },
    {
      id: 'fg-scoring',
      title: 'Punktacja',
      body: `Użyj notesu i licz każdą kategorię osobno. Na końcu odejmij wszystkie widoczne minusy na planszy osady, wyspach i budynkach. Kafle dóbr zwykle nie dają osobnych VP — liczy się to, co zakryły i uruchomiły.`,
      requiredModuleIds: ['base'],
    },
  ],
} as const;
